import React from "react";
import { Fragment } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../static/css/homeresponsive.css";

function SliderHome(images) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <Fragment>
      <div className="hero__wrapper hero__js">
        <Slider {...settings}>
          {images.images.map((item, i) => {
            return (
              <div key={i} className="hero__item">
                <div className="hero__itemWrapper">
                  <div className="hero__left">
                    <div className="hero__title">{item.tittle}</div>
                    <div className="hero__content">{item.content}</div>
                  </div>
                  <div className="hero__right">
                    <div className="hero__image">
                      <img src={item.url} alt=""></img>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </Fragment>
  );
}

export default SliderHome;
